import React from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FacilityUserRole } from '../../services/apiTypes';

interface UserWithPermissions {
    permissions?: FacilityUserRole[];
}

/**
 * Valid FacilityUserRole must have facilityId to grant facility access.
 */
function hasFacilityUserRoles(permissions: unknown): permissions is FacilityUserRole[] {
    if (!Array.isArray(permissions) || permissions.length === 0) {
        return false;
    }
    return permissions.some(
        (p): p is FacilityUserRole => !!p && typeof (p as FacilityUserRole).facilityId === 'string'
    );
}

const NoFacilityRolesView: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div
            className="no-data-container"
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '200px',
                color: '#fff',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    maxWidth: 400,
                    padding: 24,
                }}
            >
                <h2 style={{ marginBottom: 16 }}>
                    {t('profile.noFacilityRolesAssigned')}
                </h2>
                <p>{t('profile.noFacilityRolesContactAdmin')}</p>
            </div>
        </div>
    );
};

/**
 * Renders children (via Outlet) only when user has at least one FacilityUserRole.
 * Otherwise shows NoFacilityRolesView instead of spinning indefinitely.
 */
export const FacilityRolesGate: React.FC = () => {
    const stored = localStorage.getItem('user') || '{}';
    const user: UserWithPermissions = JSON.parse(stored);
    const permissions = user?.permissions ?? [];

    if (!hasFacilityUserRoles(permissions)) {
        return <NoFacilityRolesView />;
    }

    return <Outlet />;
};
